module.exports = "<div [id]=\"captchaName\"></div>"